<div class="nav-item" [class.inactive]="inactive()" [class.subnav-item]="isSubnavItem()" [class.open]="open()">
  <a #anchorRef class="nav-link" [class.fixed]="!isSubnavItem()">
    <div class="icon" [class.subnav-icon]="isSubnavItem()" [class.tagged-icon]="tag().length > 0">
      <tbs-icon size="medium" [icon]="icon()" />
    </div>
    <div class="title">
      <label class="tb-subtitle-primary">
        <span>{{ navTitle() }}</span>
        @if (tag().length > 0) {
          <span [class]="'tag tb-caption try ' + tag()">{{ tag() }}</span>
        }
      </label>
      @if (description()) {
        <span class="tb-caption">{{ description() }}</span>
      }
    </div>
    @if (haveSubnavigation()) {
      <tbs-icon icon="calcite:chevron-right-32" class="chevron-right" />
    }
  </a>

  @if (haveSubnavigation()) {
    @if (open() && submenuRef()?.el.nativeElement) {
      <app-safe-area [anchor]="anchorRef" [submenu]="submenuRef()!.el.nativeElement" />
    }
    <sidebar-subnav
      [style.visibility]="open() ? 'visible' : 'hidden'"
      (mouseenter)="cancelClose()"
      (mouseleave)="onMouseLeave()"
    >
      <ng-content />
    </sidebar-subnav>
  }
</div>
